module.exports = __webpack_public_path__ + "static/media/not-selected.cfc2ee60.png";